import React, { useEffect, useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion';
import CloseButton from '../components/common/CloseButton';
//import projectsData from '../data/projects';
import Project from '../components/projects/Project';
import { request } from 'graphql-request'


const MyWork = () => {

    //const [projects, setProjects] = useState([])

    const [projectsData, setProjectsData] = useState([])
    const [category, setCategory] = useState('all')



    useEffect(() => {
        const fetchProjects = async () => {
            const { projectsData } = await request(process.env.REACT_APP_API_URL, `{
                projectsData(where: { category_contains_all: [${category}] } first: 50 ) {
                    id
                    name
                    technology
                    category
                    image {
                        url(transformation: {image: {resize: {}}, document: {output: {}}})
                    }
                    githuburl
                    demourl
                    desc
                  }
            }`
            );
            setProjectsData(projectsData);
            //console.log(skillsData)

        }
        fetchProjects();

    }, [category])

    const handleFilterCategory = (name) => {
        const fetchProjects = async () => {
            const { projectsData } = await request(process.env.REACT_APP_API_URL, `{
                projectsData(where: { category_contains_all: [${name}] } first: 50 ){
                    id
                    name
                    technology
                    category
                    image {
                        url(transformation: {image: {resize: {}}, document: {output: {}}})
                    }
                    githuburl
                    demourl
                    desc
                  }
            }`
            );
            setProjectsData(projectsData);
            //console.log(skillsData)

        }
        fetchProjects();
        setCategory(name)
    }

    return (
        <motion.div
            className='h-full'
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: .4 }}
        >
            <div className='bg-white dark:bg-gray-900 p-5 rounded-custom z-40 '>
                <div className='flex justify-between items-center'>
                    <h4 className='text-center font-bold text-4xl text-slate-900 dark:text-white tracking-wide uppercase'>My <span className='text-skin-base'>Work</span></h4>
                    <CloseButton />
                </div>
                <div className='h-[calc(100vh-130px)] md:h-[calc(100vh-155px)] overflow-y-auto mt-4'>
                    <div className='flex flex-col'>
                        <div className='flex flex-wrap justify-center items-center gap-2 md:gap-3 bg-slate-100/50 dark:bg-slate-800/50 rounded-custom p-2 mb-4'>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'all' ? ' border-[3px] border-white/40 opacity-100' : ''}`} onClick={() => { handleFilterCategory('all'); setCategory('all'); }}>All</button>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'react' ? ' border-[3px] border-white/40 opacity-100' : ''}`} onClick={() => handleFilterCategory('react')}>React</button>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'php' ? ' border-[3px] border-white/40 opacity-100' : ''}`} onClick={() => handleFilterCategory('php')}>PHP</button>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'mern' ? ' border-[3px] border-white/40 opacity-100' : ''}`} onClick={() => handleFilterCategory('mern')}>MERN</button>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'ui' ? ' border-[3px] border-white/40  opacity-100' : ''}`} onClick={() => handleFilterCategory('ui')}>UI Design</button>
                            <button className={`bg-skin-fill px-4 py-1 text-white text-lg rounded-custom font-semibold opacity-90 hover:opacity-100 cursor-pointer ${category === 'logo' ? ' border-[3px] border-white/40  opacity-100' : ''}`} onClick={() => handleFilterCategory('logo')}>Logo Design</button>
                        </div>
                        <motion.div layout className='flex flex-wrap justify-center md:justify-start gap-4 p-2'>
                            <AnimatePresence>
                                {
                                    projectsData.map((item, i) =>
                                        <Project
                                            key={i} item={item} projectsData={projectsData}
                                        ></Project>
                                    )
                                }
                            </AnimatePresence>
                        </motion.div>
                    </div>
                </div>
            </div>
        </motion.div>

    )
}

export default MyWork